<template>
	<div class="root">
		<vipMeetingHeader/>
		<div class="container">
			<div class="result-icon">
				<img src="@/assets/order/success.png">
			</div>
			<div class="title">支付成功</div>
			<div class="limit-width order-top">
				<div class="orderno">订单编号: {{ order.OrderNo }}</div>
				<div class="orderstatus">{{ order.OrderStatusLabel }}</div>
			</div>
			<div class="limit-width product">
				<div class="p-item">
					<div class="p-name">生活馆</div>
					<div class="p-price">{{ order.StoreName }}</div>
				</div>
				<div class="p-item">
					<div class="p-name">日期</div>
					<div class="p-price">{{order.BookingDate}}</div>
				</div>
				<div class="p-item">
					<div class="p-name">预约时段</div>
					<div class="p-price">{{order.BeginTime}} - {{order.EndTime}}</div>
				</div>
				<div class="p-item">
					<div class="p-name">价格</div>
					<div class="p-price">{{ order.PriceType==1?'点数':'￥' }}{{ order.Price }}</div>
				</div>
				<div class="p-item" v-if="order.CreateTime">
					<div class="p-name">{{ order.PriceType==1?'支付':'预约' }}时间</div>
					<div class="p-price">{{ order.CreateTime.substr(0,19).replace("T", " ") }}</div>
				</div>
			</div>
			<div class="limit-width total">合计：{{ order.PriceType==1?'点数':'￥' }}{{ order.Amount }}</div>
			<div class="limit-width tips">
				<p>限时免费取消预约：</p>
				<p>截止预约日期前一天，可自主免费取消预约；超时限后不再接受取消，如未出席仍视为占用。</p>
			</div>
			<div class="bottom">
				<Button @click='goHome' size='large' class='pay-btn' type='primary'>再次预约</Button>
			</div>
		</div>
		
	</div>
</template>

<script>
	import vipMeetingHeader from '@/components/header/vipMeetingHeader'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				order:{
					PriceType:null,
					OrderNo:null,
					OrderStatusLabel:'',
					StoreName:'',
					BookingDate:null,
					BeginTime:null,
					EndTime:null,
					Price:null,
					CreateTime:null,
					Amount:null,
				}
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			vipMeetingHeader,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getVIPReservationOrdersAction'
			]),
			async initData(){
				let LifeVIP_006 = await this.getVIPReservationOrdersAction({
					BookingId:this.$route.query?.code
				})
				this.order = LifeVIP_006[0]
			},
			goHome(){
				this.$router.push('/vipmeeting/home')
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		display:block;
		background-color: white;
	}
	.container {
		padding-top:0.8rem;
		margin:auto;
		max-width: 1400px;
	}
	.result-icon {
		width: 150px;
		height: 150px;
		border-radius: 100px;
		background-color:$green;
		margin:auto;
		display:flex;
		align-items: center;
		justify-content: center;
		margin-top: 60px;
		box-shadow: 1px 1px 20px #dddddd8c;
		img {
			width:80px;
		}
	}
	.title {
		color: $green;
		font-weight: bold;
		@include fontSize($font-size-24);
		text-align:center;
		margin-top: 20px;
	}
	.limit-width {
		max-width: 700px;
		margin:auto;
	}
	.order-top {
		display:flex;
		justify-content: space-between;
		margin-top: 20px;
		border-bottom:1px solid #aaa;
		padding-bottom: 10px;
		.orderno {
			@include fontSize($font-size-16);
		}
		.orderstatus {
			@include fontSize($font-size-14);
			color:$theme-color;
			border:1px solid $theme-color;
			padding:2px 15px;
			border-radius: 20px;
		}
	}
	.product {
		.p-item {
			display:flex;
			justify-content: space-between;
			@include fontSize($font-size-16);
			margin-top: 10px;
		}
	}
	.total {
		margin-top: 30px;
		text-align: right;
		@include fontSize($font-size-24);
		color:red;
		padding-bottom: 10px;
		border-bottom:1px solid #aaa;
	}
	.tips{
		p:first-child{
			color:#B176C5;
			margin: 20px 0 10px 0;
			@include fontSize($font-size-18);
		}
		p:nth-child(2){
			@include fontSize($font-size-13);
		}
	}
	.bottom {
		display:flex;
		margin:40px 0;
		justify-content: center;
		.pay-btn {
			width:330px;
			border-radius: 30px;
			height:50px;
		}
	}
	@media (max-width: 768px){
		.container {
			padding:0 10px;
		}
		.result-icon {
			width: 120px;
			height: 120px;
			img {
				width:70px;
			}
		}
		.title {
			font-size: 20px;
			margin-top: 10px;
		}
		.order-top {
			margin-top: 40px;
			.orderno {
				font-size: 16px;
			}
			.orderstatus {
				font-size: 14px;
			}
		}
		.product {
			.p-item {
				font-size: 16px;
			}
		}
		.total {
			margin-top: 20px;
			font-size: 22px;
		}
		.tips{
			p:first-child{
				color:#B176C5;
				margin: 10px 0;
				font-size: 16px;
			}
			p:nth-child(2){
				font-size: 14px;
			}
		}
		.bottom {
			margin:30px 0 20px 0;
			.pay-btn {
				height:40px;
			}
		}
	}
</style>